/**
 * Internal to edge-ai (TTSPlayer). Not exported from the package index — the
 * frontend uses its ApiClient, which injects the token itself.
 */

/**
 * Build request headers with a JSON content type and an optional
 * `Authorization: Bearer <token>` when a token getter is provided.
 */
export async function buildAuthHeaders(
  getAuthToken?: () => Promise<string>,
): Promise<Record<string, string>> {
  const headers: Record<string, string> = { 'Content-Type': 'application/json' }
  if (getAuthToken) {
    headers['Authorization'] = `Bearer ${await getAuthToken()}`
  }
  return headers
}
